<template>
  <div class="node-state">
    <div class="info">
      <div class="data">
        <div class="state">
          <div>{{$t('superNode.stateTitle')}}</div>
          <div>{{nodeState}}</div>
        </div>
        <div class="vote">
          <div>{{$t('superNode.totalVottstitle')}}</div>
          <div>{{formatTokenWithoutSymbol(nodeVotes)}}</div>
        </div>
        <div class="rank">
          <div>{{$t('superNode.rankTitle')}}</div>
          <div>{{nodeRanking}}</div>
        </div>
      </div>
      <div class="ops">
        <dna-button class="btn-update" @click="onUpdateClick">{{$t('superNode.updateBtn')}}</dna-button>
        <div class="btn-fee">{{$t("asset.updateWitnessFee")}}{{formatToken(fee)}}</div>
        <!-- <dna-button class="btn-exit" @click="onExitClick">{{$t('superNode.exitBtn')}}</dna-button> -->
      </div>
    </div>
    <!-- 表格 -->
    <div class="history">
      <div class="table">
        <!-- 表头 -->
        <div class="head">
          <div>{{$t('superNode.currentRankingTitle')}}</div>
          <div>{{$t('superNode.detailsTitle')}}</div>
          <div>{{$t('superNode.lastTimeTitle')}}</div>
          <div>{{$t('superNode.effectTimeTitle')}}</div>
          <div>{{$t('superNode.operationTitle')}}</div>
        </div>
        <!-- 表身 -->
        <div class="body" v-for="(item, index) in tableData.filter(it=>it.show)" :key="index">
          <div>{{item.ranking}}</div>
          <div>{{item.details}}</div>
          <div>{{item.lastTime}}</div>
          <div>{{item.effectTime}}</div>
          <div>
            <a @click="item.onChangeClick">{{$t('superNode.changeLink')}}</a>
          </div>
        </div>
      </div>
      <!-- <div class="page-con">
        <Page :total="100" show-elevator/>
      </div>-->
    </div>
    <!-- Update确认 -->
    <dna-modal
      :isShow="isUpdateConfirmModalShow"
      :isHeaderShow="false"
      @closed="isUpdateConfirmModalShow = false"
    >
      <div class="confirm-modal-content">{{$t('superNode.updateConfirmText')}}</div>
      <div class="confirm-modal-footer">
        <dna-button :type="'cancel'" @click="onUpdateCancelClick">{{$t('global.cancel')}}</dna-button>
        <dna-button @click="onUpdateConfirmClick">{{$t('global.confirm')}}</dna-button>
      </div>
    </dna-modal>

    <!-- Exit确认 -->
    <dna-modal
      :isShow="isExitConfirmModalShow"
      :isHeaderShow="false"
      @closed="isExitConfirmModalShow = false"
    >
      <div class="confirm-modal-content">{{$t('superNode.exitConfirmText')}}</div>
      <div class="confirm-modal-footer">
        <dna-button :type="'cancel'" @click="onExitCancelClick">{{$t('global.cancel')}}</dna-button>
        <dna-button @click="onExitConfirmClick">{{$t('global.confirm')}}</dna-button>
      </div>
    </dna-modal>

    <!-- 更新团队介绍 -->
    <dna-modal
      :isShow="isUpdateTeamIntroShow"
      :isHeaderShow="false"
      @closed="isUpdateTeamIntroShow = false"
      :width="1080"
    >
      <div class="update-modal-content">
        <div class="title">{{$t("superNode.teamIntroTitle")}}</div>
        <textarea
          :placeholder="$t('superNode.teamIntroTips')"
          v-model="teamIntro"
          @input="onIntroInput"
        ></textarea>
      </div>
      <div class="update-modal-footer">
        <dna-button :type="'cancel'" @click="onTeamIntroCancelClick">{{$t('global.cancel')}}</dna-button>
        <dna-button @click="onTeamIntroConfirmClick">{{$t('global.confirm')}}</dna-button>
      </div>
    </dna-modal>

    <!-- 更新社区建设计划 -->
    <dna-modal
      :isShow="isUpdatePlanShow"
      :isHeaderShow="false"
      @closed="isUpdatePlanShow = false"
      :width="1080"
    >
      <div class="update-modal-content">
        <div class="title">{{$t('superNode.buildingPlanTitle')}}</div>
        <textarea
          :placeholder="$t('superNode.buildingPlanTips')"
          v-model="plan"
          @input="onPlanInput"
        ></textarea>
      </div>
      <div class="update-modal-footer">
        <dna-button :type="'cancel'" @click="onPlanCancelClick">{{$t('global.cancel')}}</dna-button>
        <dna-button @click="onPlanConfirmClick">{{$t('global.confirm')}}</dna-button>
      </div>
    </dna-modal>

    <!-- 更新扣留比例 -->
    <dna-modal
      :isShow="isUpdateRatioShow"
      :isHeaderShow="false"
      @closed="isUpdateRatioShow = false"
      :width="525"
    >
      <div class="update-modal-content small">
        <div class="title">{{$t("superNode.dividendRatioTitle")}}</div>
        <textarea
          ref="ratioRef"
          class="percent"
          placeholder
          @input="onPercentInput"
          @focus="onPercentFocus"
          v-model="ratio"
        ></textarea>
      </div>
      <div class="update-modal-footer small">
        <dna-button :type="'cancel'" @click="onRatioCancelClick">{{$t('global.cancel')}}</dna-button>
        <dna-button @click="onRatioConfirmClick">{{$t('global.confirm')}}</dna-button>
      </div>
    </dna-modal>

    <!-- 更新签名公钥 -->
    <dna-modal
      :isShow="isSignKeyShow"
      :isHeaderShow="false"
      @closed="isSignKeyShow = false"
      :width="625"
    >
      <div class="update-modal-content small">
        <div class="title">{{$t("superNode.signKeyTitle")}}</div>
        <textarea
          ref="signKeyRef"
          class="signkey-input"
          @input="onSignKeyInput"
          placeholder
          v-model="signKey"
        ></textarea>
      </div>
      <div class="update-modal-footer small">
        <dna-button :type="'cancel'" @click="onSignKeyCancelClick">{{$t('global.cancel')}}</dna-button>
        <dna-button @click="onSignKeyConfirmClick">{{$t('global.confirm')}}</dna-button>
      </div>
    </dna-modal>

    <dna-spin v-if="isLoading"></dna-spin>
    <!-- 输入密码 -->
    <dna-password-modal
      :isShow="isPasswordModalShow"
      @closed="isPasswordModalShow = false"
      @confirm="onPasswordConfirm"
    ></dna-password-modal>
  </div>
</template>

<script>
import wsSubscribe from "@/req/wsSubscribe.js";
import tx from "@/req/tx.js";
import req from "@/req/req.js";
import UTIL from "@/util/util.js";
import ERROR from "@/util/error.js";
import wallet from "@/util/wallet.js";
const PasswordType = {
  UPDATE: 0,
  EXIT: 1,
  INTRODUCTION: 2,
  PLAN: 3,
  RATIO: 4,
  SIGNKEY: 5,
};
export default {
  data() {
    return {
      isPasswordModalShow: false,
      isLoading: true,
      passwordType: PasswordType.UPDATE,
      isUpdateConfirmModalShow: false,
      isExitConfirmModalShow: false,
      isUpdateTeamIntroShow: false,
      isUpdateRatioShow: false,
      isUpdatePlanShow: false,
      isSignKeyShow: false,
      teamIntro: "",
      plan: "",
      ratio: "80%",
      nodeState: "",
      nodeVotes: "",
      nodeRanking: "",
      signKey: "",
      fee: 0,
      tableData: [
        {
          ranking: this.$t("superNode.team"),
          show: false,
          details: "",
          lastTime: "-",
          effectTime: "-",
          onChangeClick: this.onTeamIntroChangeClick,
        },
        {
          ranking: this.$t("superNode.community"),
          show: false,
          details: "",
          lastTime: "-",
          effectTime: "-",
          onChangeClick: this.onPlanChangeClick,
        },
        {
          ranking: this.$t("superNode.dividendRatio"),
          show: true,
          details: "0%",
          lastTime: "-",
          effectTime: "-",
          onChangeClick: this.onRatioChangeClick,
        },
      ],
    };
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      let that = this;
      try {
        await that.loadVoteState();
        await that.loadNodeInfo();
        await that.loadFee();
        this.isLoading = false;
      } catch (err) {
        console.log(err);
        that.isLoading = false;
        let msg = that.$t("global.networkError");
        that.$Message.error({
          background: true,
          duration: 5,
          content: msg,
        });
      }
    },

    async loadFee() {
      let that = this;
      let feeResults = await wsSubscribe.wsFetchOperationFees([
        "witness_update",
      ]);

      if (feeResults.length) {
        that.fee = feeResults[0].fee;
      }
    },
    /** 获取票数 */
    async loadVoteState() {
      let that = this;
      if (!this.address) {
        return;
      }
      let account = that.address;
      //account = "mvs"; //TODO:这里测试的
      //获取票数
      let witnessAccount = await wsSubscribe.wsFetchWitnessByAccount(account);
      console.log("witnessAccount:" + JSON.stringify(witnessAccount));
      if (witnessAccount) {
        that.nodeVotes = witnessAccount.total_votes;
        if (typeof witnessAccount.block_producer_reward_pct != "undefined") {
          let currentRatio = witnessAccount.block_producer_reward_pct / 100;
          let nextRatio = witnessAccount.next_block_producer_reward_pct / 100;
          let ratio =
            that.$t("superNode.currentRatio") + currentRatio.toFixed(2) + "%";
          if (nextRatio != currentRatio) {
            ratio +=
              "   " +
              that.$t("superNode.nextRatio") +
              nextRatio.toFixed(2) +
              "%";
          }
          that.tableData[2].details = ratio;
          that.ratio = nextRatio.toFixed(2) + "%";
        }
      }
      //获取排名
      let witnesses = await wsSubscribe.wsFetchAllWitness();
      //console.log(witnesses)
      witnesses = witnesses.sort((a, b) => {
        return a.total_votes < b.total_votes ? 1 : -1;
      });
      let index = witnesses.map((it) => it.id).indexOf(witnessAccount.id);
      that.nodeRanking = UTIL.paddingZero(index + 1, 2);
      //23个超级节点，20个备用节点
      that.nodeState =
        index < 23
          ? that.$t("superNode.nodeTypeSuperNode")
          : index < 43
          ? that.$t("superNode.nodeTypeAlternateNode")
          : that.$t("superNode.nodeTypeFullNode");
    },
    async loadNodeInfo() {
      if (!this.address) {
        return;
      }
      let account = this.address;
      //account = "mvs";
      //获取团队介绍和建设计划
      let nodeInfo = await req.fetchTargetNodeInfo(account);
      if (nodeInfo) {
        this.tableData[0].details = nodeInfo.introduction;
        //TODO:时间字段
        let introTime =
          nodeInfo.introductionChangeTime || new Date().toLocaleString();
        this.tableData[0].lastTime = "-";
        this.tableData[0].effectTime = "-";

        //TODO:时间字段
        let planTime = nodeInfo.planChangeTime || new Date().toLocaleString();
        this.tableData[1].details = nodeInfo.plan;
        this.tableData[1].lastTime = "-";
        this.tableData[1].effectTime = "-";
      }
    },
    //本地私钥签名
    async updateNodeInfo(mnemonic, introduction, plan) {
      let that = this;

      let walletInfo = wallet.getAccountInfo(mnemonic, that.net);

      let update = {};
      if (introduction) {
        update.introduction = introduction;
      }
      if (plan) {
        update.plan = plan;
      }
      let public_key = walletInfo.publicKey;
      let private_key = walletInfo.privateKey;

      let body = {
        timestamp: new Date().getTime(),
        request_data: update,
        publickey: public_key,
        signature: "",
      };
      //签名
      let sigbuf = Buffer.concat([
        that.stringToBuf(body.timestamp.toString()),
        that.stringToBuf(JSON.stringify(body.request_data)),
      ]);
      let sig = wallet.sign(private_key, public_key, sigbuf);
      body.signature = sig.toHex(); // + "error";
      //console.log(JSON.stringify(body));

      let result = await req.updateNodeInfo(that.address, body);
      that.tableData[0].details = introduction;
      that.tableData[1].details = plan;
      //console.log(result);
    },
    async updateSignKey(mnemonic, signKey) {
      let that = this;

      that.isLoading = true;
      if (that.net == "bts") {
        // BTS网络下，查询该ID对应信息
        let walletInfo = wallet.getAccountInfo(mnemonic, that.net);
        let userInfo = that.$store.state.userInfo;
        let updateResult = await tx.registerOrUpdateWitness(
          walletInfo.privateKey,
          userInfo.name,
          signKey,
          "",
          0
        );
        let txId =
          updateResult && updateResult.length ? updateResult[0].id : "";
        that.$Message.success({
          background: true,
          duration: 3,
          content: that.$t("superNode.updateSignKeySuccess") + " " + txId,
        });
      }
      if (that.net == "sub") {
        // SUB网络
      }
      await this.load();
      this.isLoading = false;
    },
    async updateNodeRatio(mnemonic, ratio) {
      let that = this;
      console.log("updateNodeRatio:" + ratio);
      ratio = parseFloat(ratio);
      if (isNaN(ratio) || ratio < 0 || ratio > 100) {
        let msg = that.$t("superNode.wrongRatioMsg");
        that.$Message.error({
          background: true,
          duration: 5,
          content: msg,
        });
        return;
      }
      ratio = parseInt(ratio * 100);

      that.isLoading = true;
      if (that.net == "bts") {
        // BTS网络下，查询该ID对应信息
        let walletInfo = wallet.getAccountInfo(mnemonic, that.net);
        let userInfo = that.$store.state.userInfo;
        let updateResult = await tx.registerOrUpdateWitness(
          walletInfo.privateKey,
          userInfo.name,
          "",
          "",
          ratio
        );
        let txId =
          updateResult && updateResult.length ? updateResult[0].id : "";
        that.$Message.success({
          background: true,
          duration: 3,
          content: that.$t("superNode.updateRatioSuccess") + " " + txId,
        });
      }
      if (that.net == "sub") {
        // SUB网络
      }
      await this.load();
      this.isLoading = false;
    },
    stringToBuf(str) {
      let hex = "";
      for (var i = 0; i < str.length; i++) {
        hex += "" + str.charCodeAt(i).toString(16);
      }
      console.log("stringToBuf:" + str);
      console.log("hex:" + hex);
      console.log(new Buffer(hex, "hex"));
      console.log(new Buffer(str, "utf-8"));

      return new Buffer(hex, "hex");
    },

    formatTokenWithoutSymbol(val) {
      return UTIL.formatToken(val, [], 4, ""); //
    },
    formatToken(val) {
      return UTIL.formatToken(val, [], 4); //
    },
    // 点击更新按钮，弹出更新确认
    onUpdateClick() {
      this.isSignKeyShow = true;
    },
    // 确认更新
    onUpdateConfirmClick() {
      this.isUpdateConfirmModalShow = false;
      this.passwordType = PasswordType.UPDATE;
      this.isPasswordModalShow = true;
      //TODO:
    },
    // 取消更新
    onUpdateCancelClick() {
      this.isUpdateConfirmModalShow = false;
    },

    //点击退出按钮，弹出退出确认
    onExitClick() {
      this.isExitConfirmModalShow = true;
    },
    //确认退出
    onExitConfirmClick() {
      this.isExitConfirmModalShow = false;
      this.passwordType = PasswordType.EXIT;
      this.isPasswordModalShow = true;
      //TODO:
    },
    //取消退出
    onExitCancelClick() {
      this.isExitConfirmModalShow = false;
    },

    // 点击修改Team introduction，弹出修改框
    onTeamIntroChangeClick() {
      this.isUpdateTeamIntroShow = true;
    },
    // 确认修改Team introduction
    onTeamIntroConfirmClick() {
      this.isUpdateTeamIntroShow = false;
      this.passwordType = PasswordType.INTRODUCTION;
      this.isPasswordModalShow = true;
    },
    // 取消修改Team introduction
    onTeamIntroCancelClick() {
      this.isUpdateTeamIntroShow = false;
    },

    // 点击修改Dividend ratio，弹出修改框
    onRatioChangeClick() {
      this.isUpdateRatioShow = true;
    },
    // 确认修改Dividend ratio
    onRatioConfirmClick() {
      this.isUpdateRatioShow = false;
      this.passwordType = PasswordType.RATIO;
      this.isPasswordModalShow = true;
    },
    // 取消修改Dividend ratio
    onRatioCancelClick() {
      this.isUpdateRatioShow = false;
    },

    // 点击修改Comminity plan，弹出修改框
    onPlanChangeClick() {
      this.isUpdatePlanShow = true;
    },
    // 确认修改Comminity plan
    onPlanConfirmClick() {
      this.isUpdatePlanShow = false;
      this.passwordType = PasswordType.PLAN;
      this.isPasswordModalShow = true;
    },
    // 取消修改Comminity plan
    onPlanCancelClick() {
      this.isUpdatePlanShow = false;
    },

    onSignKeyInput(e) {
      let value = e.target.value;
      this.signKey = value;
    },
    // 确认Signkey
    onSignKeyConfirmClick() {
      let that = this;
      that.isSignKeyShow = false;
      let isPublicKey = wallet.isPublicKey(that.signKey);
      if (!isPublicKey) {
        let msg = that.$t("superNode.incorrectPublicKey");
        that.$Message.error({
          background: true,
          duration: 5,
          content: msg,
        });
        return;
      }
      this.passwordType = PasswordType.SIGNKEY;
      that.isPasswordModalShow = true;
    },
    // 取消Signkey
    onSignKeyCancelClick() {
      this.isSignKeyShow = false;
    },

    onIntroInput(e) {
      let value = e.target.value;
      this.teamIntro = value;
    },
    onPlanInput(e) {
      let value = e.target.value;
      this.plan = value;
    },
    // 百分比修改，控制%和光标位置
    onPercentInput(e) {
      let value = e.target.value;
      value = value.replace(/%/g, "");
      let fValue = parseFloat(value);
      value += "%";
      this.ratio = value;
      this.onPercentFocus();
      // var textArea = this.$refs.ratioRef;
      // setImmediate(() => {
      //   //e.currentTarget
      //   let s = this.ratio.length > 0 ? this.ratio.length - 1 : 0;
      //   textArea.setSelectionRange(s, s);
      // });
    },
    onPercentFocus(e) {
      var textArea = this.$refs.ratioRef;
      setImmediate(() => {
        //e.currentTarget
        let s = this.ratio.length > 0 ? this.ratio.length - 1 : 0;
        textArea.setSelectionRange(s, s);
      });
    },

    // 密码确认
    async onPasswordConfirm(pw) {
      let that = this;
      this.isPasswordModalShow = false;

      try {
        // TODO: 用户输入判断
        let userInfo = that.$store.state.userInfo;
        let mnemonic = UTIL.decryptKey(userInfo.key, pw);
        if (!mnemonic) {
          that.isLoading = false;
          that.$Message.error({
            background: true,
            duration: 5,
            content: that.$t("global.passwordError"),
          });
          return;
        }
        switch (that.passwordType) {
          case PasswordType.UPDATE:
            break;
          case PasswordType.SIGNKEY:
            let isPublicKey = wallet.isPublicKey(that.signKey);
            if (!isPublicKey) {
              let msg = that.$t("superNode.incorrectPublicKey");
              that.$Message.error({
                background: true,
                duration: 5,
                content: msg,
              });
              return;
            }
            await that.updateSignKey(mnemonic, that.signKey);
            break;
          case PasswordType.EXIT:
            break;
          case PasswordType.INTRODUCTION:
            await that.updateNodeInfo(
              mnemonic,
              that.teamIntro,
              that.tableData[1].details
            );
            break;
          case PasswordType.PLAN:
            await that.updateNodeInfo(
              mnemonic,
              that.tableData[0].details,
              that.plan
            );
            break;
          case PasswordType.RATIO:
            await that.updateNodeRatio(mnemonic, that.ratio);
            break;
        }
      } catch (err) {
        that.isLoading = false;
        let msg =
          ERROR.getCustomMessage(err, that.$t.bind(that)) ||
          that.$t("global.networkError");
        that.$Message.error({
          background: true,
          duration: 5,
          content: msg,
        });
      }
    },
  },
  computed: {
    net() {
      return this.$store.state.net;
    },
    address() {
      return (
        this.$store.state.userInfo.name || this.$store.state.userInfo.address
      );
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./SuperNodeState.less");
</style>